import { render, staticRenderFns } from "./TheGameGalleryIntro.vue?vue&type=template&id=a6515a24"
import script from "./TheGameGalleryIntro.vue?vue&type=script&lang=js"
export * from "./TheGameGalleryIntro.vue?vue&type=script&lang=js"
import style0 from "./TheGameGalleryIntro.vue?vue&type=style&index=0&id=a6515a24&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports